import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import Enllac from 'components/corporatiu/Enllac';

import Image from 'next/image';
import { dataResources } from 'utils/constants';
import MenuLogin from '../MenuLogin';

import styles from './menusticky.module.scss';

import __isEmpty from 'lodash/isEmpty';

const imageLoader = ({ src }) => {
    return `${src}`;
};

const MenuCorporate = ({ requiredServices, estil }) => {
    const { basePath } = dataResources;

    const stylesCorporate = clsx({
        [styles.corporate]: true,
        [styles.isSticky]: true,
        [styles.isNoti]: estil === 'itemNoticia'
    });

    return (
        <nav aria-label='Menú corporatiu' className={stylesCorporate} id='navegacio'>
            <div className={styles.barra_wrapper}>
                <div className={styles.barra}>
                    <div className={styles.barra_logo}>
                        <Enllac href='/3cat/'>
                            <div className={styles.logo3cat}>
                                <Image
                                    loader={imageLoader}
                                    unoptimized={true}
                                    width={82}
                                    height={24}
                                    alt='Logo 3Cat'
                                    src={basePath + '/_resources/logos/3cat_color.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                />
                            </div>
                        </Enllac>
                    </div>
                    <div className={`${styles.iconesLink} ${styles.iconesUser} ${styles.logoRebaixat}`}>
                        <MenuLogin requiredServices={requiredServices} className={styles.login} />
                    </div>
                </div>
            </div>
        </nav>
    );
};

const MenuSticky = ({
    requiredServices,
    isSideMenuOpen,
    setIsSideMenuOpen,

    estil
}) => {
    const accessibilityRefs = {
        closeMenu: useRef(null),
        openMenu: useRef(null)
    };

    useEffect(() => {
        if (isSideMenuOpen === 'opened') {
            document.body.style.overflow = 'hidden';
            accessibilityRefs.closeMenu.current?.focus();
        } else if (isSideMenuOpen === 'closing') {
            document.body.style.overflow = 'auto';
            accessibilityRefs.openMenu.current?.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSideMenuOpen]);

    return (
        <>
            <MenuCorporate
                requiredServices={requiredServices}
                isSideMenuOpen={isSideMenuOpen}
                setIsSideMenuOpen={setIsSideMenuOpen}
                accessibilityRefs={accessibilityRefs}
                estil={estil}
            />
        </>
    );
};

export default MenuSticky;
